import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "shared/components/Form/Select";
import {
  COLOR_BLACK,
  COLOR_GREY100,
  COLOR_WHITE,
  COLOR_GREY200,
  COLOR_LIGHT_BLUE,
  COLOR_BLACK_TRANSPARENT,
  COLOR_GREY400,
  COLOR_PRIMARY_MAIN,
  COLOR_GREY_8,
} from "shared/theme/colors";
import { border } from "shared/theme/mixins";

export const StyledPopper = {
  "& .MuiPaper-root": {
    borderRadius: "16px",
    width: "328px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",

    "& .MuiPickersCalendarHeader-label": {
      fontWeight: 500,
      fontSize: "14px",
    },

    "& .MuiDayPicker-weekDayLabel": {
      fontWeight: 500,
      fontSize: "14px",
    },

    "& .MuiPickersDay-root.Mui-selected": {
      backgroundColor: COLOR_PRIMARY_MAIN,
      borderRadius: "0.5rem",
      fontWeight: 500,
      fontSize: "14px",
    },

    "& .MuiPickersDay-root:not(.Mui-selected)": {
      borderRadius: "0.5rem",
      fontWeight: 500,
      fontSize: "14px",
    },

    "& .MuiPickersCalendarHeader-switchViewIcon": {
      height: "20px",
      width: "20px",
      fill: COLOR_GREY_8,
    },
  },
};

export const StyledContainer = styled(Box)`
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
`;

export const StyledDateTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    padding: 0;
    width: 156px;
    padding-right: 1rem;
    border-radius: 8px;
    ${border(1, COLOR_GREY100)};

    &.Mui-focused {
      color: ${COLOR_GREY400};
      background-color: ${COLOR_WHITE};

      .MuiOutlinedInput-notchedOutline {
        ${border(2, COLOR_LIGHT_BLUE)}
        padding: 0 calc(1rem - 1px);
        box-shadow: ${COLOR_BLACK_TRANSPARENT(0.05)} 0 0 0 4px;
        border-radius: 8px;
      }

      textarea.MuiOutlinedInput-input {
        padding: "1rem";
      }
    }

    .MuiOutlinedInput-input {
      font-size: 14px;
      color: ${COLOR_BLACK};
      border-radius: 8px;
      height: 40px;
      padding: 0 1rem;
      padding-right: 0;
      box-shadow: rgba(115, 125, 255, 0) 0 0 0 4px;
      transition: box-shadow 0.3s;
      background-color: ${COLOR_WHITE};

      :hover {
        border: none;
      }

      ::placeholder {
        color: ${COLOR_GREY200};
        opacity: 1;
      }
    }

    & .MuiInputAdornment-root {
      width: 1.5rem;
    }

    &.Mui-error {
      .MuiOutlinedInput-notchedOutline {
        box-shadow: none;
        border-radius: 8px;
      }
    }

    .MuiOutlinedInput-notchedOutline {
      border: unset;
    }

    &.Mui-disabled {
      .MuiOutlinedInput-input {
        background-color: transparent;
      }
    }
  }
`;

export const TimeSelect = styled(Select)`
  width: 127px;
`;
